import React from 'react';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';
import { getDataTestId } from '../../../../shared/esm';
import { useInputProgress } from './useInputProgress.js';

var styles = {"component":"pass-code__component_eqvnl","dotWrapper":"pass-code__dotWrapper_eqvnl","dot":"pass-code__dot_eqvnl","filled":"pass-code__filled_eqvnl","animatedFill":"pass-code__animatedFill_eqvnl","dotFilled":"pass-code__dotFilled_eqvnl","error":"pass-code__error_eqvnl","success":"pass-code__success_eqvnl","dotSuccessFilled":"pass-code__dotSuccessFilled_eqvnl","rawSuccess":"pass-code__rawSuccess_eqvnl"};
require('./index.css');

var transitions = {"enter":"pass-code__enter_1xltb","enterActive":"pass-code__enterActive_1xltb","exit":"pass-code__exit_1xltb","exitActive":"pass-code__exitActive_1xltb","shake":"pass-code__shake_1xltb"};
require('./transitions.css');

/* eslint-disable react/no-array-index-key */
var TRANSITION_DURATION = 150;
var InputProgress = function (_a) {
    var _b;
    var _c = _a.value, value = _c === void 0 ? '' : _c, maxCodeLength = _a.maxCodeLength, codeLength = _a.codeLength, error = _a.error, dataTestId = _a.dataTestId, success = _a.success;
    var _d = useInputProgress(success), rawSuccess = _d.rawSuccess, resetSuccessAnimation = _d.resetSuccessAnimation;
    return (React.createElement("div", { className: cn(styles.component, (_b = {}, _b[transitions.shake] = error, _b)), "data-test-id": getDataTestId(dataTestId, 'input-progress') }, codeLength
        ? new Array(codeLength).fill(null).map(function (_, i) {
            var _a;
            var filled = Boolean(value[i]);
            return (React.createElement("div", { className: cn(styles.dotWrapper), key: i },
                React.createElement("div", { className: cn(styles.dot, (_a = {},
                        _a[styles.error] = filled && error,
                        _a[styles.animatedFill] = filled,
                        _a[styles.success] = success,
                        _a)) })));
        })
        : new Array(maxCodeLength).fill(null).map(function (_, i) {
            var _a;
            return (React.createElement(CSSTransition, { key: i, in: Boolean(value[i]), timeout: TRANSITION_DURATION, classNames: transitions, unmountOnExit: true },
                React.createElement("div", { className: cn(styles.dot, styles.filled, (_a = {},
                        _a[styles.error] = error,
                        _a[styles.success] = success && !rawSuccess,
                        _a[styles.rawSuccess] = success && rawSuccess,
                        _a)), onAnimationEnd: resetSuccessAnimation })));
        })));
};

export { InputProgress };
